export const TEXTS = {
  NEWER_VERSION_EXISTS: 'Newer version exists',
  CLICK_TO_READ_REPORT: 'Click to read the report',
  EXPERT_CHIP_LABEL: (name: string, versionDate?: string): string => (versionDate ? `${name} · ${versionDate}` : name),
};
